import React, { useEffect, useRef, useState } from "react";
import { StickyBar, Title, Sentry } from "./styles";
import { useHeader } from "./store";

const Header = () => {
  const { title, buttons } = useHeader();

  const [stuck, setStuck] = useState(false);
  const sentryRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = sentryRef.current;
    if (!el) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        setStuck(!entry.isIntersecting);
      },
      { root: null, threshold: 0 }
    );

    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <>
      <Sentry ref={sentryRef} />

      <StickyBar $stuck={stuck}>
        <Title>{title}</Title>
        {buttons}
      </StickyBar>
    </>
  );
};

export default Header;
